import { useEffect, useContext, useState } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import GlobalContext from '../../../contexts';
import globalTranslating from '../../../translate.json';
import terapistTranslating from '../translate.json';
import fields from '../fields';
import { useNavigate } from 'react-router-dom';
import { isValidIsraeliID } from '../../../utils';

const CreateTerapist = () => {
  const translating = { ...globalTranslating, ...terapistTranslating };
  const navigate = useNavigate();
  const { postData, res, error } = usePostData();
  const { categoriesList, setLink, regionEnum } = useContext(GlobalContext);
  const [errFun, setErrFun] = useState();

  useEffect(() => {
    if (error) {
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    } else if (res?.id) {
      setLink(null);
      navigate(`/therapists?added=true`);
    }
  }, [res, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    if (!isValidIsraeliID(data.ssn))
      setError('ssn', {
        type: 'invalidTZ',
        message: translating.invalidTZ
      });
    else {
      postData('user/therapist', data);
    }
  };

  return (
    <div className="create-terapist">
      <SectionHeader title={translating.createTerapistTitle}></SectionHeader>
      <FormGroup
        fields={fields(categoriesList, regionEnum, true)}
        onSubmit={onSubmit}
        categories={categoriesList}
      ></FormGroup>
    </div>
  );
};

export default CreateTerapist;
